export function normalizeSizePriceMap(priceBySize) {
  if (!priceBySize || typeof priceBySize !== "object") return {};

  return Object.fromEntries(
    Object.entries(priceBySize)
      .map(([size, price]) => [String(size || "").trim(), Number(price)])
      .filter(([size, price]) => size && Number.isFinite(price) && price >= 0)
  );
}

export function getProductPriceForSize(product, size = "") {
  const prices = normalizeSizePriceMap(product?.priceBySize);
  const cleanSize = String(size || "").trim();

  if (product?.hasVariableSizePrices && cleanSize && prices[cleanSize] != null) {
    return prices[cleanSize];
  }

  return Number(product?.price || 0);
}

export function getProductMinimumPrice(product) {
  const basePrice = Number(product?.price || 0);
  const prices = Object.values(normalizeSizePriceMap(product?.priceBySize));

  if (!product?.hasVariableSizePrices || prices.length === 0) return basePrice;

  return Math.min(...prices, basePrice);
}

export function formatProductPrice(product, size = "") {
  const selectedPrice = getProductPriceForSize(product, size);

  if (product?.hasVariableSizePrices && !size) {
    return `Από ${getProductMinimumPrice(product)}€`;
  }

  return `${selectedPrice}€`;
}
